﻿export const hasAttribute = (field, name) => field.getAttribute(name) != null;

const hasClass = (field, className) => field.classList.contains(className);

export const hasPattern = field => hasAttribute(field, 'pattern');

export const isRequired = field => hasAttribute(field, 'required');

export const isGroupRequired = field => hasAttribute(field, 'group-required');

export const accessibleInvalid = field => hasAttribute(field, 'aria-invalid');

export const isReadOnly = field => hasAttribute(field, 'readonly') || field.readOnly;

export const isDisabled = field => hasAttribute(field, 'disabled') || field.disabled;

export const hasMatching = field => hasAttribute(field, 'data-matching-text');

export const hasOptionValidate = field => hasAttribute(field, 'data-runtime-validate');

export const hasRuntimeValidate = field => hasClass(field, 'js-runtime-validate');

export const hasBlankAndPattern = field => hasPattern(field) && hasClass(field, 'js-validation-blank');

export const hasPatternOnlyValidation = field => hasAttribute(field, 'pattern-only-validation');

export const shouldBeValidated = field => {
    if (!hasPatternOnlyValidation(field) && !isRequired(field) && !field.value && !hasBlankAndPattern(field) && !isGroupRequired(field)) {
        return false;
    } else {
        return (!isReadOnly(field) &&
            !isDisabled(field) &&
            (hasPattern(field) || hasMatching(field) || isRequired(field)) || isGroupRequired(field));
    }
};

export const matchesPattern = field => {
    try { 
        if (!hasPattern(field)) {
            return false;
        } else {
            var pattern = field.getAttribute('pattern');

            return (field.value || hasBlankAndPattern(field)) && new RegExp(pattern).test(field.value);
        }
    }
    catch (error) {
        console.error(error.message);
    }
};

export const matchingText = field => {
    try {
        if (!hasMatching(field)) {
            return false;
        } else {
            const fieldToMatch = field.getAttribute('data-matching-text');
            const matchingElement = document.getElementById(fieldToMatch);

            return matchingElement === null || field.value === matchingElement.value;
        }
    }
    catch (error) {
        console.error(error.message);
    }
};

export const hasMinimumOptionsChecked = field => {
    var nodeList = document.getElementsByName(field.name);

    var minRequiredOptions = field.getAttribute('min-required');

    if (isNaN(minRequiredOptions)) {
        return false;
    }

    if (nodeList && nodeList.length > 0) {
        var group = Array.from(nodeList);

        var checkedItems = group.filter(function (element) {
            return element.checked;
        });

        return checkedItems.length >= minRequiredOptions;
    }

    return false;
};

export const disableSubmitButton = btn => {

    if (btn) {
        btn.setAttribute("disabled", "true");
    }
};